<script setup lang="ts">
import YscInputGroup from './YscInputGroup.vue'
import { defineModel } from '#imports'

interface Props {
  id: string
  required?: boolean
  disabled?: boolean
  placeholder?: string
  rows?: number
}

withDefaults(defineProps<Props>(), {
  required: false,
  disabled: false,
  placeholder: undefined,
  rows: 10,
})
const modelValue = defineModel<string | null>()
</script>

<template>
  <YscInputGroup
    :for="id"
    :required="required"
    :disabled="disabled"
  >
    <template
      v-if="$slots.default"
      #default
    >
      <slot />
    </template>

    <template #inputBlock>
      <textarea
        :id="id"
        ref="textarea"
        v-bind="$attrs"
        v-model="modelValue"
        :name="id"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :required="required"
        class="focus-visible:border-peacock-300 focus-visible:ring-peacock-300 block w-full cursor-text appearance-none rounded-sm border border-gray-300 bg-white px-4 py-3 text-base leading-normal outline-none placeholder:text-gray-500 focus-visible:ring-1 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:ring-0 disabled:ring-offset-0"
      />
    </template>

    <template
      v-if="$slots.description"
      #description
    >
      <slot name="description" />
    </template>
  </YscInputGroup>
</template>
